export enum TransactionIntent {
  Unknown = 'Unknown',
  NotSure = 'NotSure',
  Sell = 'Sell',
  Trade = 'Trade'
}

export enum LifeCycleState {
  Active = 'Active',
  AppliedToPurchase = 'AppliedToPurchase', // Treat like Active
  Expired = 'Expired',
  Manual = 'NeedsManualAppraisal',
  Rejected = 'Rejected', // Treat like Manual
  Scheduled = 'Scheduled' // Treat like Active
}

type AcquisitionVehicle = {
  color: string;
  make: string;
  mileage: number;
  model: string;
  trim: string;
  year: number;
};

type AcquisitionSummary = {
  daysToExpiration: number | null;
  id: string;
  isAlmostExpired: boolean | null;
  lifeCycleState: LifeCycleState;
  offerAmount: number;
  transactionIntent: TransactionIntent;
  vehicle: AcquisitionVehicle;
};

type AcquisitionsErrors = {
  message: string;
  locations: Array<{ line: number; column: number }>;
  path: string[];
  extensions: Record<any, any>;
};

export type AcquisitionsApiResponse = {
  errors?: AcquisitionsErrors[];
  data: { acquisitionSummaries: AcquisitionSummary[] | null };
};

export default AcquisitionSummary;
